import React from "react";
import { useState, useEffect, useRef, useInterval } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import * as intchaine from "./interface-chaine";
import * as mem from "./recopieLotFournisseur";
import axios from "axios";
import * as d3 from "d3";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { ImSpinner3 } from "react-icons/im";
import "./App.css";
import "./tree.css";
import { DEBUG } from "./utilitaires";

export default function PreparerEtAussiAfficherGraphe() {
  const ref = useRef();

  const [stringLot, setStringLot] = useState("");
  const [stringDepth, setStringDepth] = useState("");
  const [messageErreurLot, setMessageErreurLot] = useState("");
  const [messageErreurDepth, setMessageErreurDepth] = useState("");
  const [messageModal, setMessageModal] = useState("");
  const [isloading, setIsLoading] = useState(false);

  var msgErreurLot = "",
    msgErreurDepth = "";
  var treeData = [];

  //pour le modal
  const [show, setShow] = useState(false);
  const [msgModal, setMsgModal] = useState("");
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function handleLot(e, value) {
    e.preventDefault();
    setStringLot(value);
  }

  function handleDepth(e, value) {
    e.preventDefault();
    setStringDepth(value);
  }

  async function construireTreeData(lotATracer, profondeur) {
    var arbre = {};
    var infosLot = await intchaine.getInfosLot(lotATracer);

    var lotsFi = infosLot[6];
    var pourcentL = infosLot[7];
    //tri selon pourcentages decroissants
    let lotsindex = [];
    for (let i = 0; i < lotsFi.length; i++) {
      lotsindex.push({ 0: lotsFi[i], 1: pourcentL[i] });
    }
    lotsindex.sort(function (a, b) {
      return parseInt(b[1], 10) - parseInt(a[1], 10);
    });
    lotsFi = [];
    for (let i = 0; i < lotsindex.length; i++) {
      lotsFi.push(lotsindex[i][0]);
    }
    pourcentL = [];
    for (let i = 0; i < lotsindex.length; i++) {
      pourcentL.push(lotsindex[i][1]);
    }
    // fin du tri

    var libelle = infosLot[2];

    arbre.numL = lotATracer;
    arbre.libel = libelle;
    arbre.children = [];
    // arbre.push({ numL: lotATracer, libel: libelle, children : [] });

    lotsFi = lotsFi.map((item) => parseInt(item, 10));

    if (profondeur > 0) {
      for (var i = 0; i < lotsFi.length; i++) {
        arbre.children.push(
          await construireTreeData(lotsFi[i], profondeur - 1)
        );
      }
    }
    return arbre;
  }

  async function handleTracerLot(e) {
    e.preventDefault();
    msgErreurLot = "";
    msgErreurDepth = "";
    setMessageErreurLot("");
    setMessageErreurDepth("");
    setIsLoading(true);
    const svgElement = d3.select(ref.current);
    svgElement.selectAll("svg").remove();
    try {
      var lotATracer = parseInt(stringLot, 10);
      if (isNaN(lotATracer)) {
        throw "err";
      }
      if (!(await intchaine.existeLot(lotATracer))) {
        throw "err";
      }
      if (lotATracer <= 0) {
        throw "err";
      }
      // setNumLot(lotATracer);
    } catch {
      // setTreeData([]);
      msgErreurLot = "Erreur dans le numero de Lot";
      setMessageErreurLot("Erreur dans le numero de Lot");
      setIsLoading(false);
      const svgElement = d3.select(ref.current);
      svgElement.selectAll("svg").remove();
    }
    try {
      var profondeur = parseInt(stringDepth, 10);
      if (isNaN(profondeur)) {
        profondeur = 3;
        //throw "err";
      } else if (profondeur > 5) {
        profondeur = 5;
      }
      // setProf(profondeur);
    } catch {
      // setTreeData([]);
      msgErreurDepth = "Erreur dans la profondeur";
      setMessageErreurDepth("Erreur dans la profondeur");
      setIsLoading(false);
      const svgElement = d3.select(ref.current);
      svgElement.selectAll("svg").remove();
    }
    if (DEBUG) console.log("lot a tracer:", lotATracer);
    if (msgErreurLot || msgErreurDepth) {
      return;
    }
    treeData = [await construireTreeData(lotATracer, profondeur)];

    if (DEBUG) console.log("treeData: ", treeData);
    tracerGraphe();
    setIsLoading(false);
  }

  function tracerGraphe() {
    if (DEBUG) console.log("treeData dans Afficher:", treeData);
    // var margin = { top: 20, right: 120, bottom: 20, left: 120 },
    var margin = { top: 0, right: 120, bottom: 0, left: 180 }, //margin left 120
      // width = 960 - margin.right - margin.left,
      // height = 600 - margin.top - margin.bottom;
      width = 960 - margin.right - margin.left,
      height = 400 - margin.top - margin.bottom;

    var i = 0,
      duration = 750,
      root;

    var tree = d3.layout.tree().size([height, width]);

    var diagonal = d3.svg.diagonal().projection(function (d) {
      return [d.y, d.x];
    });

    const svgElement = d3.select(ref.current);
    svgElement.selectAll("svg").remove();

    var svg = //d3.select("body")
      svgElement
        .append("svg")
        .attr("width", width + margin.right + margin.left)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    root = treeData[0];
    root.x0 = height / 2;
    root.y0 = 0;

    update(root);

    //   d3.select(self.frameElement).style("height", "500px");
    d3.select(window.frameElement).style("height", "500px");

    function update(source) {
      // Compute the new tree layout.
      var nodes = tree.nodes(root).reverse(),
        links = tree.links(nodes);

      // Normalize for fixed-depth.
      nodes.forEach(function (d) {
        d.y = d.depth * 100; //180
      });

      // Update the nodes…
      var node = svg.selectAll("g.node").data(nodes, function (d) {
        return d.id || (d.id = ++i);
      });

      // Enter any new nodes at the parent's previous position.
      var nodeEnter = node
        .enter()
        .append("g")
        .attr("class", "node")
        .attr("transform", function (d) {
          return "translate(" + source.y0 + "," + source.x0 + ")";
        })
        // .on("dblclick", click)
        .on("click", click) //rajout hover après click
        .on("mouseover", function (d, i) {
          var g = d3.select(this); // The node
          // The class is used to remove the additional text later
          var info = g
            .append("text")
            .classed("info", true)
            .attr("x", function (d) {
              return d.children || d._children ? 13 : -13;
            })
            .attr("dy", ".35em")
            .attr("text-anchor", function (d) {
              return d.children || d._children ? "start" : "end";
            })
            .text(function (d) {
              return "Lot " + d.numL; //d.libel; d.name
            })
            .attr("fill", "red");
          //  .text('More info');
        })
        .on("mouseout", function () {
          // Remove the info text on mouse out.
          d3.select(this).select("text.info").remove();
        });

      //   d3.select(this)
      //     .append("text")
      //     .attr("x", function (d) {
      //       return d.children || d._children ? 13 : -13;
      //     })
      //     .attr("dy", "-1.35em") //.35
      //     .attr("text-anchor", function (d) {
      //       return d.children || d._children ? "end" : "start";
      //     })
      //     .text(function (d) {
      //       return " " + d.libel; //d.name
      //     })
      //     .attr("fill", "red")
      //     .transition()
      //     .duration("1500")
      //     .remove();
      // });

      nodeEnter
        .append("circle")
        .attr("r", 1e-6)
        .style("fill", function (d) {
          return d._children ? "lightsteelblue" : "#fff";
        });

      nodeEnter
        .append("text")
        .attr("x", function (d) {
          return d.children || d._children ? -13 : 13;
        })
        .attr("dy", ".35em")
        .attr("text-anchor", function (d) {
          return d.children || d._children ? "end" : "start";
        })
        .text(function (d) {
          return "" + d.libel; //"Lot " + d.numL;     d.name
        })
        .style("fill-opacity", 1e-6); //opacity à 1e-6

      // Transition nodes to their new position.
      var nodeUpdate = node
        .transition()
        .duration(duration)
        .attr("transform", function (d) {
          return "translate(" + d.y + "," + d.x + ")";
        });

      nodeUpdate
        .select("circle")
        .attr("r", 10)
        .style("fill", function (d) {
          return d._children ? "lightsteelblue" : "#fff";
        });

      nodeUpdate.select("text").style("fill-opacity", 1); //opacity à 1

      // Transition exiting nodes to the parent's new position.
      var nodeExit = node
        .exit()
        .transition()
        .duration(duration)
        .attr("transform", function (d) {
          return "translate(" + source.y + "," + source.x + ")";
        })
        .remove();

      nodeExit.select("circle").attr("r", 1e-6);

      nodeExit.select("text").style("fill-opacity", 1e-6);

      // Update the links…
      var link = svg.selectAll("path.link").data(links, function (d) {
        return d.target.id;
      });

      // Enter any new links at the parent's previous position.
      link
        .enter()
        .insert("path", "g")
        .attr("class", "link")
        .attr("d", function (d) {
          var o = { x: source.x0, y: source.y0 };
          return diagonal({ source: o, target: o });
        });

      // Transition links to their new position.
      link.transition().duration(duration).attr("d", diagonal);

      // Transition exiting nodes to the parent's new position.
      link
        .exit()
        .transition()
        .duration(duration)
        .attr("d", function (d) {
          var o = { x: source.x, y: source.y };
          return diagonal({ source: o, target: o });
        })
        .remove();

      // Stash the old positions for transition.
      nodes.forEach(function (d) {
        d.x0 = d.x;
        d.y0 = d.y;
      });

      //tooltip (à faire...)
    }

    // Toggle children on click.
    function click(d) {
      if (d.children) {
        d._children = d.children;
        d.children = null;
      } else {
        d.children = d._children;
        d._children = null;
      }
      // update(d);
      // setShow(true);
      montrerLot(d.numL);
    }
  }

  var messageMontrerLot;

  async function montrerLot(numL) {
    if (DEBUG) console.log("je montre le lot: ", numL);
    var infosLot = await intchaine.getInfosLot(numL);
    var {
      0: typeLot,
      1: nomLot,
      2: libelle,
      3: hashIm,
      4: descrL,
      5: argum,
      6: lotsFi,
      7: pourcentL,
      8: lotsP,
      9: idF,
      10: dateL,
      11: noteL,
      12: classementL,
      13: fabL,
      14: catL,
      15: paysL,
      16: pourcentExt,
      17: carbone,
      18: carboneTot,
      19: carbonePert,
      20: carboneRaj,
      21: DLC,
      22: rappel
    } = infosLot;
    var nomFournisseur = await intchaine.getNomFournisseurParNumF(idF);

    if (hashIm) {
      if (DEBUG) console.log("dans Graphe, je vais appeler axios pour image");
      let res = null;
      try {
        res = await axios.get(
          "https://" + mem.addressIPRemoteimages + ":3008/download",
          // "https://" + mem.addressIPRemoteimages + ":3008/download",
          {
            responseType: "blob",
            params: { fichierImage: hashIm },
            timeout: 10000,
          }
        );
      } catch {
        alert("Problème avec le serveur d'images");
      }
      if (DEBUG) console.log(res.data);
      var dataUrl = URL.createObjectURL(res.data);
    }

    if (DEBUG) console.log("je mets à jour le message montrerlot");

    messageMontrerLot = (
      <>
        {/* <img src={dataUrl} alt="image produit" width={100} height={100} /> */}
        {/* <br /> */}
        <p>
          <span style={{ color: "blue" }}>
            Numero de lot dans la blockchain:
          </span>{" "}
          {numL}
        </p>
        {hashIm && (
          <>
            <p style={{ color: "blue" }}>Image:</p>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
              <img src={dataUrl} alt="produit" width={100} height={100} />{" "}
            </span>
            <br />
          </>
        )}
        <br />
        {typeLot == "traceur" && (
          <>
            <p style={{ color: "blue" }}>QR Code:</p>
            <QRCodeCanvas
              value={numL.toString()}
              size={256}
              bgColor={"#ffffff"}
              //fgColor={"#000000"}
              fgColor={"red"}
              level={"H"}
              includeMargin={true}
              imageSettings={{src:"text-to-image.png", height: 20, width: 20  ,excavate: true}}
            />
          </>
        )}
        <p>
          <span style={{ color: "blue" }}>Type du Lot: </span>
          {typeLot}
        </p>
        <p>
          <span style={{ color: "blue" }}>Numéro de Lot Fournisseur: </span>
          {nomLot}
        </p>
        <p>
          <span style={{ color: "blue" }}>Dénomination: </span>
          {libelle}
        </p>

        {typeLot == "traceur" && (
          <p>
            <span style={{ color: "blue" }}>Fichier image: </span>
            {hashIm}
          </p>
        )}

        <p style={{ whiteSpace: "pre-wrap" }}>
          <span style={{ color: "blue" }}>Description: </span>
          {descrL}
        </p>

        {typeLot == "traceur" && (
          <>
            <p style={{ whiteSpace: "pre-wrap" }}>
              <span style={{ color: "blue" }}>
                Votre Argumentaire pour ce lot:{" "}
              </span>
              <br />
              {argum}
            </p>
            <p style={{ whiteSpace: "pre-wrap" }}>
              <span style={{ color: "blue" }}>
                Pourcentage dans le contenu d'ingrédients extérieurs:{" "}
              </span>
              {pourcentExt}
            </p>
            <p>
              <span style={{ color: "blue" }}>Lots Fils: </span>
              {lotsFi && lotsFi.join(", ")}
            </p>
            <p>
              <span style={{ color: "blue" }}>
                Pourcentages dans le contenu des Lots Fils:{" "}
              </span>
              {pourcentL && pourcentL.join(", ")}
            </p>
          </>
        )}

        <p>
          <span style={{ color: "blue" }}>Lots Pères: </span>
          {lotsP && lotsP.join(", ")}
        </p>

        {typeLot == "traceur" && (
          <>
            <p>
              <span style={{ color: "blue" }}>
                Empreinte carbone des ingrédients internes:{" "}
              </span>
              {carbone}
            </p>
            <p>
              <span style={{ color: "blue" }}>Empreinte carbone Totale: </span>
              {carboneTot}
            </p>
            <p>
              <span style={{ color: "blue" }}>
                Empreinte carbone pertinente:{" "}
              </span>
              {carbonePert.toString()}
            </p>
            <p>
              <span style={{ color: "blue" }}>
                Empreintes carbone rajoutées pour les lots fils:{" "}
              </span>
              {carboneRaj && carboneRaj.join(", ")}
            </p>
          </>
        )}

        {typeLot == "fournisseur" && (
          <>
            <p>
              <span style={{ color: "blue" }}>
                Empreinte carbone:{" "}
              </span>
              {carbone}
            </p>
            <p>
              <span style={{ color: "blue" }}>
                Empreinte carbone pertinente:{" "}
              </span>
              {carbonePert.toString()}
            </p> 
          </>
        )}

        {typeLot == "traceur" && (
          <>
            <p>
              <span style={{ color: "blue" }}>Fournisseur: </span>
              {nomFournisseur}
            </p>
            <p>
              <span style={{ color: "blue" }}>Note: </span>
              {noteL}
            </p>
            <p>
              <span style={{ color: "blue" }}>Classement: </span>
              {classementL}
            </p>
            <p>
              <span style={{ color: "blue" }}>
                Date limite de consommation:{" "}
              </span>
              {DLC}
            </p>

            <p>
              <span style={{ color: "blue" }}>
                Rappel:{" "}
              </span>
              {rappel.toString()}
            </p>            
          </>
        )}

        {typeLot == "fournisseur" && (
          <>
            <p>
              <span style={{ color: "blue" }}>Fabricant: </span>
              {fabL}
            </p>
            <p>
              <span style={{ color: "blue" }}>Pays du Fabricant: </span>
              {paysL}
            </p>
          </>
        )}

        <p>
          <span style={{ color: "blue" }}>
            Date de création sur la Blockchain:{" "}
          </span>
          {dateL}
        </p>
        <p>
          ---------------------------------------------------------------------------------------
        </p>
        <br />
      </>
    );
    setMessageModal(messageMontrerLot);
    setShow(true);
  }

  //   return <svg viewBox="0 0 900 500" ref={ref} />;
  return (
    <>
      <h5 style={{ textAlign: "center" }}>Chaîne de tracabilité</h5>
      {/* <br/> */}
      {/* boxview 900 600 */}
      <Form style={{ backgroundColor: "#d4d6d9", marginBottom: "5px" }}>
        <Row>
          <Col>
            <Form.Label className="ps-2">Lot à tracer</Form.Label>
            <Form.Control
              as="textarea"
              rows={1}
              placeholder="entrez le lot à tracer"
              value={stringLot}
              onChange={(e) => handleLot(e, e.target.value)}
            />
          </Col>{" "}
          <Col>
            <Form.Label className="ps-2">
              Profondeur (limitée à 5, defaut 3)
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={1}
              placeholder="entrez la profondeur"
              value={stringDepth}
              onChange={(e) => handleDepth(e, e.target.value)}
            />
          </Col>
        </Row>
      </Form>{" "}
      <Button
        style={{ fontSize: 12, padding: 3 }}
        variant="outline-primary"
        onClick={handleTracerLot}
      >
        Tracer ce Lot
      </Button>
      <br />
      {isloading && (
        <ImSpinner3
          color="grey"
          icon="spinner"
          className="spinner"
          style={{ height: 100, width: 100 }}
        />
      )}
      {messageErreurLot && messageErreurLot}
      <br />
      {messageErreurDepth && messageErreurDepth}
      <svg viewBox="0 0 1000 600" ref={ref} />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Informations Lot</Modal.Title>
        </Modal.Header>
        <Modal.Body>{messageModal}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
